/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Modal component to handle footer errors
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationCommon } from '../../../../modules/internationalization/intSelectors';
import { ICommonTranslation } from '../../../../modules/internationalization/types';
import { IRootReducer } from '../../../../reducers/rootReducer';
import { TextBlock } from '../../../common';
import { FooterModalStyled, FooterModalTextStyled, FooterModalTitleStyled } from './styled/footerModalStyled';

interface IConnectedProps {
    translation: ICommonTranslation;
}

export interface IFooterErrorModalProps {
    message: string;
    onCloseModal: () => void;
    title?: string;
}

export type TFooterErrorModal = IFooterErrorModalProps & IConnectedProps;

const FooterErrorModal = (props: TFooterErrorModal) => {
    return (
        <FooterModalStyled
            data-component={'modal-popup'}
            data-name={'footer-error-modal'}>
            <FooterModalTitleStyled className="mb-3">
                {props.title || props.translation.modal.error + '!'}
            </FooterModalTitleStyled>
            <FooterModalTextStyled className="mb-5">
                <TextBlock>{props.message}</TextBlock>
            </FooterModalTextStyled>
        </FooterModalStyled>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(FooterErrorModal);
